import React from "react";
import { useTranslation } from "react-i18next";
import { MainLayout } from "components/layouts";
import TableAntd from "components/elements/Table";
import { Switch, Breadcrumb, Space, Dropdown } from "antd";
import { EditOutlined, DeleteOutlined, MoreOutlined } from "@ant-design/icons";

const AdminCampaigsPromotions = () => {
  const { t } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">{t("admin_setting.label.number_list")}</div>,
      dataIndex: "NumberList",
      key: "NumberListt",
      width: 150,
      render: (text) => (
        <div
          style={{
            color: "#42526D",
            backgroundColor: "#F5F6F7",
            borderRadius: "20px",
            width: "max-content",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            padding: "8px 16px"
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: <div className="text-table">{t('admin_campaigns_promotions.label.name_campaigns')}</div>,
      dataIndex: "packageDetail",
      key: "packageDetail",
    },
    {
      title: <div className="text-table">{t('employee.label.employee_nationality')}</div>,
      dataIndex: "PromotionType",
      key: "PromotionType",
    },
    {
      title: <div className="text-table">{t('employee.label.period')}</div>,
      dataIndex: "period",
      key: "period",
    },
    {
      title: <div className="text-table">{t('status.entity')}</div>,
      dataIndex: "status",
      key: "status",
      render: (status) => <Switch checked={status} />,
    },
    {
      title: <div className="text-table" style={{ textAlign: "center" }}>{t('admin_campaigns_promotions.label.create_by')}</div>,
      dataIndex: "CreateBy",
      key: "CreateBy",
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: (text, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: t("action.edit"),
                icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
              },
              {
                key: "2",
                label: t("action.delete"),
                icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />,
              },
            ],
          }}
        >
          <MoreOutlined style={{ fontSize: "20px", color: "gray", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];


  const data = [
    {
      key: "1",
      NumberList: "1",
    },

  ];

  return (
    <MainLayout>
      <Space size={24} direction="vertical" style={{ width: "100%" }}>
        <div style={{ marginBottom: 16 }}>
          <Breadcrumb
            items={[
              { title: t("configuration.header"), href: "/admin/response_company" },
              { title: t("admin_campaigns_promotions.header"), href: "" },
              { title: t('employee.label.description') },
            ]}
          />
          <h2>{t('admin_campaigns_promotions.label.campaigns_promotions_detail')}</h2>
          <span style={{ color: "#667085" }}>
            {t('admin_campaigns_promotions.label.Manage _used _campaigns _and _promotions')}
          </span>
        </div>

        <TableAntd columns={columns} />
      </Space>
    </MainLayout>
  );
};

export default AdminCampaigsPromotions;

